<template>
  <div v-if="showAlert">
    <b-collapse :visible="showAlert" id="crisis" class="crisis-management-wrapper">
      <div class="container-crisis">
          <div class="col-12 int-banner pt-3 pb-3">
            <a tabindex="0" href="" @click="showAlertDetails = !showAlertDetails" onclick="return false;" class="cm-link" :class="this.$store.state.crisisManager.alert.message_type">
              {{ this.$store.state.crisisManager.alert.message_type }}
              <span v-if="this.$store.state.crisisManager.alert.message_type != 'State of Emergency'"> Alert</span>
              &mdash; {{ this.$store.state.crisisManager.alert.message }}</a>
          </div>
            <div v-if="showAlertDetails" v-on:click="showAlertDetails = false" class="col-lg-12 text-right pt-4"><button v-if="showAlertDetails" href="#" aria-haspopup="true" aria-expanded="true" class="text-right icon-close"></button></div>
        <div class="box-shadow">
        <div class="container" v-if="showAlertDetails">
          <div class="row">
            <div class="col-12 col-md-6 pb-5 text-left">
              <h2>{{ this.$store.state.crisisManager.alert.message }}</h2>
              <span v-html="this.$store.state.crisisManager.alert.body_text"/>
            </div>
            <div class="col-12 col-md-6 pb-5 mt-2 text-left">
              <!-- <h3>Accommodation Resources</h3>
              <span class="logo-list">
                <a href="https://www.booking.com/region/us/alabama.html" rel='noopener' target="_blank">
                  <img src="/images/logos/booking.png" alt="Booking.com" class="cm-logo">
                </a>
                <a href="https://www.expedia.com/Destinations-In-Alabama.d202.Hotel-Destinations" rel='noopener' target="_blank">
                  <img src="/images/logos/expedia.png" alt="Expedia" class="cm-logo">
                </a>
                <a href="https://www.orbitz.com/Destinations-In-Alabama.d202.Hotel-Destinations" rel='noopener' target="_blank">
                  <img src="/images/logos/orbitz.png" alt="Orbitz" class="cm-logo">
                </a>
              </span> -->
              <h3>Resources</h3>

              <a href="https://alabama.travel/places-to-go/map/Attractions" target="_blank" rel="noopener noreferrer" class="button  no-carrot btn-white">Interactive Map</a>

              <a href="https://alabama.travel/festivals-and-events" target="_blank" rel="noopener noreferrer" class="button no-carrot btn-link">Events</a>

              <a href="https://alabama.travel/my-trip/staying-safe" target="_blank" rel="noopener noreferrer" class="button no-carrot btn-link">Staying Safe</a>

            </div>
        </div>
        </div>
        </div>
      </div>
    </b-collapse>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator';

@Component({
  async created() {
    await this.getAlert();
    setTimeout(await this.getAlert, 1000 * 60 * 60);
  },
  data() {
    return {
      showAlertDetails: false,
    };
  },
})
class CrisisManager extends Vue {
  get showAlert() {
    if (this.$store.state.crisisManager.alert && !this.$store.state.crisisManager.collapsed) {
      this.$emit('crisisActivated');
      return true;
    }
    return false;
  }

  async getAlert() {
    await this.$store.dispatch('crisisManager/getAlert');
  }
}

export default CrisisManager;
</script>

<style lang="scss" scoped>
.btn-white {
    background-color: transparent;
    border: 1px solid #4e97b2;
    color: #2c3e50;

    &:hover,
    &:active,
    &:focus {
        background-color: #d6e7ee;
        color: #2c3e50;
    }
}

.btn-link {
    background-color: transparent;
    border: none;
    color: #2c3e50;
    margin-left: 25px;

    &:hover,
    &:active,
    &:focus {
        background-color: #d6e7ee;
        color: #2c3e50;
    }
}
.crisis-management-wrapper {
  position: absolute;
  top:0px;
  width:100%;
  background-color: white;
  z-index: 301;
}
.box-shadow {
  box-shadow: 0px 8px 5px 0px rgba(0,0,0,0.14);
-webkit-box-shadow: 0px 8px 5px 0px rgba(0,0,0,0.14);
-moz-box-shadow: 0px 8px 5px 0px rgba(0,0,0,0.14);
}
.int-banner {
  background-color: #BD5028;
}
.logo-list {
  display: block;
  margin: 10px 0 25px;
}
.logo-list a {
  margin-right:20px;
}
.cm-logo {
  width:25%;
}
a.cm-link {
  font-family: 'klinicslabbold';
  color:white;
  text-decoration: underline;
  transition: 500ms;
}
a.cm-link:hover {
  text-decoration: underline;
  color:black;
  transition: 500ms;
}
a.cm-link:focus {
  outline-color:white!important;
}
@media only screen and (max-width: 768px) {

  h2 {
    font-size:3rem;
  }
  .cm-logo {
  width:50%;
}
.logo-list a {
  margin-right:0px;
  display: block;
  margin:20px 0 10px 0;
}
a.cm-link {
  font-size:16px;
}
}
</style>
